import { Binding as BindingBase } from '@ortho-next/three-base';
export const Binding = BindingBase;
//# sourceMappingURL=Binding.js.map